
import { defineComponent } from 'vue';
import { mdiPencil, mdiDelete, mdiArrowRight, mdiEyeOff, mdiEye } from '@mdi/js';

export default defineComponent({
  components: {},
  setup() {
    return {
      mdiPencil,
      mdiDelete,
      mdiArrowRight,
      mdiEyeOff,
      mdiEye,
    };
  },
});
